import { Outlet, useHref, useSearchParams, useNavigate } from 'react-router-dom';
import Navbar from '../sharedComponents/navbar/Navbar';
import Footer from '../sharedComponents/footer/Footer';
import { useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import "./mainLayout.css"
const MainLayout = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const url = useHref();

    // Get a specific query parameter
    const myParam = searchParams.get('token');
    console.log(myParam)

    useEffect(()=>{
        if(myParam){
            // Check if we're on bookings page or have a pricing draft - let UserTokenHandler handle it
            const currentPath = url || window.location.pathname;
            const isBookingsPage = currentPath.includes('/bookings');
            const hasPricingDraft = localStorage.getItem('sundorbonPricingDraftKeep');
            
            // If on bookings or has pricing draft, skip token handling here (let UserTokenHandler do it)
            if (isBookingsPage || hasPricingDraft) {
                return;
            }
            
            // Store token as sundorbonToken (used by the app)
            localStorage.setItem('sundorbonToken', myParam);
            localStorage.setItem('token', myParam);
            
            try {
                // Decode token to get user details
                const decoded = jwtDecode(myParam);
                const userDetails = {
                    Id: decoded.UserId,
                    Name: decoded.Username || decoded.UserName,
                    Type: decoded.RoleName || decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"],
                    Email: decoded.sub || decoded.UserEmail
                };
                localStorage.setItem(
                    "sundorbonBookingUserDetails",
                    JSON.stringify(userDetails)
                );
                
                // Remove token from URL and redirect to home
                setSearchParams({});
                navigate('/', { replace: true });
            } catch (error) {
                console.error("Error decoding token:", error);
            }
        }
    },[myParam, navigate, setSearchParams, url])

    return (
        <div className={url.includes("bookings")?"MainLayoutCss pt-3  xl:pt-10":""}>
        <div className={url.includes("bookings")?"border-[#2c2c2c] rounded-[20px] lg:rounded-[35px] xl:rounded-[60px] overflow-hidden border-[7px]  lg:border-[15px] m-3 lg:m-5 xl:m-10 mt-0":""}>
            <Navbar />
            <Outlet />
            </div>
            <Footer />
        </div>
    );
};

export default MainLayout;